import type { CityConfig } from "../city-template/types";

export const strongsvilleConfig: CityConfig = {
  city: "Strongsville",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "strongsville",
  route: "/strongsville",
  title: "Emergency Passport Strongsville, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Strongsville, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cuyahoga County and the Cleveland suburbs. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Strongsville, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Strongsville and Cuyahoga County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Strongsville%20Ohio%20suburban%20town%20center%20at%20golden%20hour%20with%20modern%20shopping%20district%20and%20residential%20neighborhoods%2C%20wide%20tree-lined%20streets%20with%20autumn%20foliage%2C%20warm%20sunset%20light%20reflecting%20on%20modern%20storefronts%20and%20civic%20buildings%2C%20Cleveland%20suburb%20atmosphere%20with%20green%20parks%20and%20well-maintained%20streets%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors&width=1800&height=700&seq=strongsville-oh-hero-001&orientation=landscape",
  heroImageAlt: "Strongsville Ohio suburban town center with shopping district at golden hour",
  geoPosition: "41.3145;-81.8357",
  geoPlacename: "Strongsville, Ohio",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 340 miles from Strongsville via I-80",
  },
  nearbyCitiesZips: [
    { name: "Strongsville", zips: "44136, 44149" },
    { name: "Berea", zips: "44017" },
    { name: "Middleburg Heights", zips: "44130" },
    { name: "Brunswick", zips: "44212" },
    { name: "North Royalton", zips: "44133" },
    { name: "Broadview Heights", zips: "44147" },
    { name: "Brecksville", zips: "44141" },
    { name: "Parma", zips: "44129, 44130, 44131, 44134" },
    { name: "Lakewood", zips: "44107" },
    { name: "Westlake", zips: "44145" },
    { name: "Medina", zips: "44256" },
    { name: "Hinckley", zips: "44233" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Strongsville departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Cleveland Suburb Coverage", desc: "Serving Cuyahoga County and southwest Cleveland suburbs" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cleveland, OH", route: "/cleveland" },
    { name: "Fast passport renewal in Akron, OH", route: "/akron" },
    { name: "Emergency passport help in Medina, OH", route: "/medina" },
    { name: "Urgent passport services in Mentor, OH", route: "/mentor" },
    { name: "Same-day passport help in Lorain, OH", route: "/lorain" },
    { name: "Passport courier services in Elyria, OH", route: "/elyria" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Strongsville remotely via secure courier. We do not have a walk-in office in Strongsville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cuyahoga County and southwest Cleveland suburb travelers.",
  fpcOfficeDistance: "Serving all of Cuyahoga County and southwest Cleveland suburbs",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From Strongsville to Berea, Middleburg Heights, and Brunswick — Fast Passport Center serves the entire Cuyahoga County southwest corridor. We regularly help travelers from North Royalton, Broadview Heights, Brecksville, Parma, and Medina get their passports fast.",
  nearbyCitiesIntro: "We serve all Strongsville neighborhoods and the surrounding Cuyahoga County region including Berea, Middleburg Heights, Brunswick, North Royalton, Broadview Heights, Brecksville, Parma, Lakewood, Westlake, Medina, and Hinckley. If you are anywhere in the southwest Cleveland suburbs, we have you covered.",
  howItWorksIntro: "Most Strongsville travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Strongsville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Strongsville and Cuyahoga County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Strongsville? Here are the most common ones we hear from Cuyahoga County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Ohio Department of Health", desc: "Request certified Ohio birth certificates from the ODH Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-history-line", label: "Death Certificates — Ohio Department of Health", desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificates — Cuyahoga County Probate Court", desc: "Marriage licenses and certified copies available through the Cuyahoga County Probate Judge at 1 W Lakeside Ave, Cleveland, OH 44113.", url: "https://cuyahogacounty.gov/probate" },
    { icon: "ri-file-copy-2-line", label: "Divorce Records — Cuyahoga County Clerk of Courts", desc: "Certified divorce decrees available from the Cuyahoga County Clerk of Courts at 1200 Ontario St, Cleveland, OH 44113.", url: "https://cccourts.org/" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Ohio birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Ohio Department of Health. Fastest online option.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Strongsville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Strongsville, OH",
      rating: 5,
      text: "My passport expired two weeks before our family trip to Europe. Fast Passport Center had my renewal ready in 4 days. Incredible service — they kept me informed every step of the way.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Berea, OH",
      rating: 5,
      text: "I thought I'd have to drive to Chicago or wait weeks for an emergency passport. Fast Passport Center handled everything remotely — got mine in 36 hours. Saved me a huge hassle.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle L.",
      location: "Middleburg Heights, OH",
      rating: 5,
      text: "Business trip to Canada came up with only 5 days notice. They got me a passport in 3 business days. Professional team, great communication, and worth every penny.",
      service: "Emergency Passport",
    },
    {
      name: "Thomas H.",
      location: "Brunswick, OH",
      rating: 5,
      text: "My son's first passport for his school trip to Mexico. Fast Passport Center guided us through every document, found us the nearest acceptance facility, and had his passport ready in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "strongsville-1",
      name: "Strongsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16000 Foltz Pkwy",
      city: "Strongsville",
      state: "OH",
      zip: "44149",
      phone: "(440) 238-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Strongsville Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main facility serving Strongsville and Cuyahoga County southwest suburbs. Appointments recommended. Multiple windows available.",
      icon: "ri-mail-line",
    },
    {
      id: "strongsville-2",
      name: "Berea Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Front St",
      city: "Berea",
      state: "OH",
      zip: "44017",
      phone: "(440) 234-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Berea, near Baldwin Wallace College",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Berea and western Cuyahoga County residents. Less crowded than Strongsville. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "strongsville-3",
      name: "Middleburg Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7375 Engle Rd",
      city: "Middleburg Heights",
      state: "OH",
      zip: "44130",
      phone: "(440) 243-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Middleburg Heights, north of Strongsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Excellent option for northern Cuyahoga County residents. Easier parking than downtown Cleveland.",
      icon: "ri-mail-line",
    },
    {
      id: "strongsville-4",
      name: "Brunswick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3701 Center Rd",
      city: "Brunswick",
      state: "OH",
      zip: "44212",
      phone: "(330) 225-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Brunswick, southwest of Strongsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Brunswick, Medina, and southern Cuyahoga County residents. Ample parking. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "strongsville-5",
      name: "North Royalton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13939 Ridge Rd",
      city: "North Royalton",
      state: "OH",
      zip: "44133",
      phone: "(440) 237-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Royalton, east of Strongsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Cuyahoga County suburbs. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "strongsville-6",
      name: "Cuyahoga County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "1200 Ontario St",
      city: "Cleveland",
      state: "OH",
      zip: "44113",
      phone: "(216) 443-7936",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Cleveland, 20 miles north",
      website: "https://cpdocket.cp.cuyahogacounty.us/",
      websiteLabel: "Cuyahoga County Courts",
      notes: "Full-service court clerk with passport acceptance. Good alternative for those who prefer court clerk over post office.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Strongsville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cuyahoga County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Strongsville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cuyahoga County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Strongsville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Strongsville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Strongsville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Strongsville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Strongsville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Strongsville?", a: "Fast Passport Center offers fast passport renewal in Strongsville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Strongsville?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 340 miles from Strongsville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cuyahoga County residents." },
    { q: "Can I expedite a child passport in Strongsville?", a: "Yes. Fast Passport Center expedites child passports in Strongsville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Cuyahoga County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Strongsville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Strongsville?", a: "The nearest regional passport agency to Strongsville is the Chicago Passport Agency, approximately 340 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Strongsville without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "How do I find a passport acceptance facility near Strongsville?", a: "Cuyahoga County has several passport acceptance facilities including the Strongsville Post Office, Berea Post Office, Middleburg Heights Post Office, Brunswick Post Office, North Royalton Post Office, and the Cuyahoga County Clerk of Courts. We can help you locate the most convenient facility and schedule your appointment." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Strongsville", address: "16700 Royalton Rd, Strongsville, OH 44136", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Strongsville", address: "14655 Pearl Rd, Strongsville, OH 44136", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Strongsville", address: "18200 Royalton Rd, Strongsville, OH 44136", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Strongsville", address: "17600 Pearl Rd, Strongsville, OH 44136", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Berea", address: "1 Front St, Berea, OH 44017", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Brunswick", address: "1281 Pearl Rd, Brunswick, OH 44212", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Middleburg Heights", address: "18340 Bagley Rd, Middleburg Heights, OH 44130", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — North Royalton", address: "13955 Ridge Rd, North Royalton, OH 44133", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Cuyahoga County BMV — Strongsville",
      address: "16700 Royalton Rd, Strongsville, OH 44136",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "BMV License Agency — Berea",
      address: "1 Front St, Berea, OH 44017",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Berea and western Cuyahoga County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "BMV License Agency — Brunswick",
      address: "3701 Center Rd, Brunswick, OH 44212",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Convenient for Brunswick, Medina, and southern Cuyahoga County residents.",
      featured: false,
    },
    {
      name: "AAA — Strongsville",
      address: "16700 Royalton Rd, Strongsville, OH 44136",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "8 miles north of Strongsville",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major international hub with flights to Europe, Canada, Mexico, and the Caribbean. Most convenient airport for Strongsville international travelers.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: true,
    },
    {
      code: "CAK",
      name: "Akron-Canton Airport",
      distance: "35 miles south of Strongsville",
      address: "5400 Lauby Rd, North Canton, OH 44720",
      note: "Regional airport with flights to Florida and seasonal destinations. Limited international options.",
      flightUrl: "https://www.akroncantonairport.com/",
      flightLabel: "Akron-Canton Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "130 miles south of Strongsville",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};